import styled from 'styled-components';

const spacers = {
  1: '0.25rem',
  3: '1rem',
};

export const Wrapper = styled.section`
  --countdown-bg-color: #000000;
  --countdown-text-color: #ffffff;

  background-color: var(--countdown-bg-color);
  color: var(--countdown-text-color);
  width: 100%;

  /* Force white text for all child elements */
  *,
  p,
  span,
  div,
  a,
  button {
    color: var(--countdown-text-color) !important;
  }

  /* Ensure button inherits white color */
  a *,
  button * {
    color: var(--countdown-text-color) !important;
  }
`;

/* Skeleton loader styles following repo pattern */
export const SkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* Skeleton loader animation from react-loading-skeleton */
  @keyframes react-loading-skeleton {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }

  .react-loading-skeleton {
    --base-color: var(--t-neutral-color-10, #ebebeb);
    --highlight-color: var(--t-neutral-color-05, #f5f5f5);
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block;

    background-color: var(--base-color);
    width: 100%;
    border-radius: ${spacers[1]};
    display: inline-flex;
    line-height: 1;
    position: relative;
    overflow: hidden;
    z-index: 1;
  }

  .react-loading-skeleton::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(90deg, var(--base-color), var(--highlight-color), var(--base-color));
    transform: translateX(-100%);
    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @media (prefers-reduced-motion) {
    .react-loading-skeleton {
      --pseudo-element-display: none;
    }
  }
`;

export const SkeletonText = styled.div`
  width: 300px;
  height: 32px;

  @media (min-width: 768px) {
    max-width: 400px;
    width: 400px;
  }

  @media (min-width: 1024px) {
    max-width: 500px;
    width: 500px;
  }
`;

export const SkeletonButton = styled.div`
  width: 120px;
  height: 32px;
`;
